import moment from 'moment';
import Datetimepicker from './Datetimepicker';

const getDefaultDate = input => {
  const proposedDate = input.val();
  if (input.data('no-default') && !proposedDate) {
    return;
  }
  const today = resetToMidnightForComparison(moment());
  const proposed = proposedDate
    ? resetToMidnightForComparison(moment(proposedDate))
    : today;
  const isInFuture = today.diff(proposed);

  const tomorrow = resetToMidnightForComparison(moment().add(1, 'day'));

  return isInFuture < 0 ? proposed : tomorrow;
};

const resetToMidnightForComparison = function(momentDate) {
  return momentDate
    .hours(0)
    .minutes(0)
    .seconds(0)
    .milliseconds(0);
};

class BookingDateInput {
  constructor(input) {
    this.input = input;
    this.initialize();
  }

  initialize() {
    if (this.input.length == 0) {
      return false;
    }

    let defaultDate = getDefaultDate(this.input);

    this.fakeInput = this.buildFakeInput(defaultDate);
    this.updateInput(defaultDate);

    this.bindEvents();
  }

  getUnavailableDates() {
    let str = this.input.data('unavailable');
    if (!str) {
      return [];
    }
    return str.split(';');
  }

  buildFakeInput(defaultDate) {
    let fakeInput = document.createElement('input');

    const options = {
      defaultDate: defaultDate,
      minDate: resetToMidnightForComparison(moment()),
      disabledDates: this.getUnavailableDates(),
      format: 'DD/MM/YYYY',
      showClear: this.input.data('show-clear')
    };

    fakeInput.setAttribute('type', 'text');
    fakeInput.classList.add('form-control', 'string', 'required');
    this.input.after($(fakeInput));

    new Datetimepicker($(fakeInput), options);

    return fakeInput;
  }

  updateInput(momentDate) {
    if (momentDate) {
      this.input.val(momentDate.format('YYYY-MM-DD'));
    } else {
      this.input.val('');
    }
  }

  bindEvents() {
    $(this.fakeInput).on('dp.change clearDate', event => {
      this.updateInput(event.date);
    });
  }
}

export default BookingDateInput;



// WEBPACK FOOTER //
// ./src/javascripts/BookingDateInput.js